export const DEFAULT_ERROR_MESSAGE = 'Не удалось обновить данные! 😞 Пожалуйста, попробуйте еще раз';
export const DEFAULT_ERROR_VISIBLE_TIME = 3000;
